import {
  CheckoutDeliveryAddressRQ,
  CheckoutInitRQ,
  PaymentMethodSelectedRQ,
  ShippingMethodSelectedRQ,
} from '../../dto/request/checkout.rerquest';

export class GetCheckoutAction {
  static readonly type = '[Shopping Cart] Get';
}

export class InitCheckoutAction {
  static readonly type = '[CheckoutState] InitCheckoutAction';

  constructor(public checkoutInitRQ: CheckoutInitRQ) {}
}

export class ClearCheckoutAction {
  static readonly type = '[CheckoutState] ClearCheckoutAction';

  constructor() {}
}

export class SippingAddressAction {
  static readonly type = '[CheckoutState] SippingAddressAction';

  constructor(
    public checkoutId: string,
    public shippingAddress: CheckoutDeliveryAddressRQ,
  ) {}
}

export class ShippingMethodAction {
  static readonly type = '[CheckoutState] ShippingMethodAction';

  constructor(
    public checkoutId: string,
    public shippingMethod: ShippingMethodSelectedRQ,
  ) {}
}

export class PaymentMethodAction {
  static readonly type = '[CheckoutState] PaymentMethodAction';

  constructor(
    public checkoutId: string,
    public paymentMethod: PaymentMethodSelectedRQ,
  ) {}
}
